import { Button } from "@/components/Core/Button";
import { DropDown } from "@/components/Core/DropDown";
import { csvFields } from "@/constant/constants";
import { ProductCsvToJsonConversion } from "@/helper/CsvToJsonConversion";
import { useState } from "react";
import { RenderToast } from "@/helper/HelperFunction";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./ImportCSVModal.module.css";
import { IoChevronBack } from "react-icons/io5";
import UploadCsvBox from "@/components/UploadCsvBox";

const ImportCSVModal = ({ show, setShow, loading, handleClick }) => {
  const [csvFile, setCsvFile] = useState(null);
  const [csvFileData, setCsvFileData] = useState(null);
  const [columns, setColumns] = useState([]);

  const handleSubmit = () => {
    const posts = makePostsFromCsvFileData(csvFileData, columns);
    if (posts?.length === 0) {
      return RenderToast({
        type: "error",
        message: "No posts found in csv file",
      });
    }
    const params = {
      posts,
    };
    handleClick(params);
  };

  return (
    <>
      <ModalSkeleton
        width={"650px"}
        header={
          csvFileData ? (
            <>
              <IoChevronBack
                className={classes.backIcon}
                onClick={() => {
                  setCsvFile(null);
                  setCsvFileData(null);
                  setColumns([]);
                }}
                size={20}
              />
              Map To Fields
            </>
          ) : (
            "Upload CSV"
          )
        }
        setShow={setShow}
        show={show}
        showCloseIcon={true}
        modalClass={classes.modalBody}
      >
        {!csvFileData ? (
          <>
            <div>
              <UploadCsvBox
                setter={async (e) => {
                  // Check validity of csv file
                  try {
                    if (!["text/csv"].includes(e?.type)) {
                      return RenderToast({
                        type: "error",
                        message: "Please upload a csv file",
                      });
                    }

                    const csvData = await new Promise((resolve) => {
                      ProductCsvToJsonConversion(e, (result) => {
                        resolve(result);
                      });
                    });
                    RenderToast({
                      type: "success",
                      message: "CSV file added successfully.",
                    });
                    setCsvFileData(csvData);
                    setCsvFile(e);
                  } catch (error) {
                    setCsvFile(null);
                    RenderToast({
                      type: "error",
                      message:
                        "An error occurred while parsing the csv file. Please check the file and try again.",
                    });
                  }
                }}
                state={csvFile}
                onDelete={() => setCsvFile(null)}
                className={classes.csvBox}
              />
            </div>
          </>
        ) : (
          <div className={classes.fieldsContainer}>
            {csvFields?.map((field, index) => (
              <div key={index} className={classes.fieldContainer}>
                <div className={classes.fieldLabel}>{field}</div>
                <p>=</p>
                <DropDown
                  //   options={generateOptions(csvFileData?.keys)?.filter(
                  //     (item) =>
                  //       !columns?.some((col) => col?.selectedKey === item?.value)
                  //   )}
                  options={generateOptions(csvFileData?.keys)}
                  value={generateOptions(csvFileData?.keys)?.find(
                    (item) => item?.value === columns?.[index]?.selectedKey
                  )}
                  setter={(e) => {
                    const updatedColumns = [...columns];
                    updatedColumns[index] = {
                      key: field,
                      selectedKey: e?.value,
                    };
                    setColumns(updatedColumns);
                  }}
                  placeholder={`Select ${field}`}
                  customStyle={{
                    border: "1px solid #ccc",
                    padding: "11.5px",
                  }}
                  hoverColor="#ccc"
                />
              </div>
            ))}
            <div className={classes.handleSubmit}>
              <Button
                label={loading ? "Submitting..." : "Submit"}
                disabled={loading}
                onClick={handleSubmit}
              />
            </div>
          </div>
        )}
      </ModalSkeleton>
    </>
  );
};

export default ImportCSVModal;

const generateOptions = (keys) => {
  return keys?.map((item) => {
    return {
      label: item,
      value: item,
    };
  });
};

const makePostsFromCsvFileData = (csvFileData, columns) => {
  const posts = [];
  csvFileData?.data?.forEach((item) => {
    const post = {};
    columns?.forEach((column) => {
      post[column?.key] = item[column?.selectedKey];
    });
    posts.push(post);
  });
  return posts;
};
